var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},[_c('pages-chat',{attrs:{"userID":_vm.userID}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }